<!--  -->
<template>
  <div class="quequred">
    <div class="seclect_box">
      <div class="search_box">
        <el-input v-model="paquery.keywords" class="seacrw" style="margin:0px" placeholder="请输入appid/ghid/公众号名称" />
        <el-input v-model="paquery.phone_name" class="seacrw" style="margin:0px" placeholder="请输入管理员手机" />
        <el-input v-model="paquery.phone_vx_account" class="seacrw" style="margin:0px" placeholder="请输入管理员微信号" />
        <el-select v-model="paquery.login_status" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button style="margin:0px" icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="reast">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-circle-plus" @click="add(1)">新增</el-button>
      </div>

    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id_text"
        label="公众号名称"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appId"
        width="180"
        align="center"
      />
      <el-table-column
        prop="gh_id"
        label="ghId"
        align="center"
      />
      <el-table-column
        prop="phone_name"
        label="管理员手机"
        align="center"
        width="250"
      />
      <el-table-column
        prop="phone_vx_account"
        label="管理员微信号"
        align="center"
      />
      <!-- <el-table-column
        prop="password"
        label="公众号密码"
        width="150"
        align="center"
      /> -->
      <el-table-column
        prop="password"
        label="登录状态"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.login_status == 1" style="color:green">{{ scope.row.login_status_text }}</div>
          <div v-if="scope.row.login_status == 2" style="color:red">{{ scope.row.login_status_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="cookies"
        label="登录成功后的cookies"
        align="center"
        width="200"
      />
      <el-table-column
        prop="login_time_text"
        label="最新登录时间"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="updated_at_text"
        label="修改时间"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="创建人"
        align="center"
      />
      <el-table-column
        fixed="right"
        prop="address"
        label="操作"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <div class="btn-wrap-box">
            <el-button size="mini" type="warning" @click="handqurde(scope.row.app_id)">手动扫码</el-button>
            <el-button size="mini" type="success">登录</el-button>
            <el-button size="mini" type="primary" @click="add(2,scope.row)">编辑</el-button>
            <el-button size="mini" type="info" @click="lookpasswordclick(scope.row.gh_id)">查看密码</el-button>
            <el-button size="mini" type="primary" @click="updatauser(scope.row.app_id)">刷新用户</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增/编辑"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <addialog ref="adrwrwlog" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="二维码"
      :visible.sync="ercodedialog"
    >
      <div v-loading="qrloading" class="img_box">
        <img :src="qr" alt="" class="img_qr">
      </div>
    </el-dialog>
    <el-dialog
      title="查看密码"
      :visible.sync="lookpassword"
    >
      <div>
        <el-tag size="small">{{ password }}</el-tag>
        <el-button
          v-clipboard:copy="password"
          v-clipboard:success="onCopys"
          v-clipboard:error="onErrors"
          style="margin-left:15px"
          type="primary"
          size="mini"
        >复制密码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { officialPwd } from '@/api/weChatMerchants.js'
import { accountloginlist, manualScandetial, updatausers } from '@/api/sourceMaterial.js'
import addialog from './components/addialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'CorrespondingAccount',
  components: {
    addialog,
    PaginationRight
  },
  data() {
    return {
      paquery: {
        keywords: null,
        phone_name: null,
        phone_vx_account: null,
        page: 1,
        page_size: 10,
        login_status: null
      },
      dialogVisible: false,
      tableData: [],
      total: null,
      loading: false,
      ercodedialog: false,
      qr: '',
      qrloading: false,
      options: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '失效'
        }
      ],
      password: '',
      lookpassword: false
    }
  },
  created() {
    this.acculist()
  },
  mounted() {

  },
  methods: {
    async acculist() {
      this.loading = true
      const data = await accountloginlist(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    add(type, item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.adrwrwlog.send(type, item)
      })
    },
    updata() {
      this.dialogVisible = false
      this.acculist()
    },
    search() {
      this.paquery.page = 1
      this.acculist()
    },
    reast() {
      this.paquery.page = 1
      this.paquery.keywords = null
      this.paquery.phone_name = null
      this.paquery.phone_vx_account = null
      this.paquery.login_status = null
      this.acculist()
    },
    // 分页
    fetchPageSize(e) {
      this.paquery.page_size = e
      this.acculist()
    },
    fetchCurrentPage(e) {
      this.paquery.page = e
      this.acculist()
    },
    async handqurde(id) {
      this.qr = ''
      this.ercodedialog = true
      this.qrloading = true
      try {
        // 你的逻辑代码
        const data = await manualScandetial({
          app_id: id
        })
        this.qr = 'data:image/png;base64,' + data.data.img
        this.qrloading = false
      } catch (e) {
        // 错误处理代码片段
        this.qrloading = false
        this.$message({
          message: '加载失败',
          type: 'error'
        })
      }
    },
    async lookpasswordclick(gh_id) {
      const data = await officialPwd({
        gh_id: gh_id
      })
      this.lookpassword = true
      this.password = data.data.password
      console.log('data', data)
    },
    onCopys() {
      this.$message({
        message: '复制密码成功',
        type: 'success'
      })
      this.lookpassword = false
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    async updatauser(appid) {
      try {
        const data = await updatausers({
          app_ids: [appid]
        })
        this.$message({
          message: '刷新用户成功',
          type: 'success'
        })
        this.acculist()
        console.log('data', data)
      } catch (err) {
        // this.updatauserbool = false
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.quequred{
  padding: 30px;
}
.seclect_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.seacrw{
  width:230px;
  margin-right: 10px;
}
.img_box{
  text-align: center;
}
.img_qr{
  width: 300px;
  height: 300px;
}
</style>
